"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleStackedLabelsForAxis = exports.autohideBarTotalLabels = exports.handleBarLabelsOutsideChart = exports.autohideBarLabels = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var sortBy_1 = tslib_1.__importDefault(require("lodash/sortBy"));
var helpers_1 = require("../../../chartTypes/_chartCreators/helpers");
var dataLabelsHelpers_1 = require("../../../chartTypes/_chartCreators/dataLabelsHelpers");
var autohideColumnLabels_1 = require("./autohideColumnLabels");
var toggleStackedChartLabels = function (visiblePoints, axisRangeForAxes) {
    var intersectionFound = visiblePoints.filter(dataLabelsHelpers_1.hasDataLabel).some(function (point) {
        var dataLabel = point.dataLabel, shapeArgs = point.shapeArgs;
        if (dataLabel && shapeArgs) {
            var dataLabelAttr = dataLabelsHelpers_1.getDataLabelAttributes(point);
            var shapeAttr = helpers_1.getShapeAttributes(point);
            return dataLabelAttr.height + 2 * dataLabel.padding > shapeAttr.height;
        }
        return false;
    });
    if (intersectionFound) {
        dataLabelsHelpers_1.hideDataLabels(visiblePoints);
    }
    else {
        visiblePoints.filter(dataLabelsHelpers_1.hasDataLabel).forEach(function (point) {
            var dataLabel = point.dataLabel, shapeArgs = point.shapeArgs, chart = point.series.chart;
            if (dataLabel && shapeArgs) {
                var dataLabelAttr = dataLabelsHelpers_1.getDataLabelAttributes(point);
                var shapeAttr = helpers_1.getShapeAttributes(point);
                var labelWidth = dataLabelAttr.width + 2 * dataLabel.padding;
                var shapeWidth = dataLabelsHelpers_1.getShapeVisiblePart(shapeArgs, chart, shapeAttr.width);
                var foundIntersection = labelWidth > shapeWidth;
                // switch axis for bar chart
                return foundIntersection
                    ? dataLabelsHelpers_1.hideDataLabel(point)
                    : dataLabelsHelpers_1.showStackLabelInAxisRange(point, axisRangeForAxes);
            }
            return null;
        });
    }
};
var toggleNonStackedChartLabels = function (points, axisRangeForAxes, shouldCheckShapeIntersection) {
    if (shouldCheckShapeIntersection === void 0) { shouldCheckShapeIntersection = false; }
    var sortedPoints = sortBy_1.default(points, function (a, b) {
        var firstLabelAttr = dataLabelsHelpers_1.getDataLabelAttributes(a);
        var nextLabelAttr = dataLabelsHelpers_1.getDataLabelAttributes(b);
        return firstLabelAttr.y - nextLabelAttr.y;
    });
    var neighbors = helpers_1.toNeighbors(sortedPoints);
    var intersectionFound = neighbors.some(function (_a) {
        var firstPoint = _a[0], nextPoint = _a[1];
        var firstDataLabelAttr = dataLabelsHelpers_1.getDataLabelAttributes(firstPoint);
        var nextDataLabelAttr = dataLabelsHelpers_1.getDataLabelAttributes(nextPoint);
        if (shouldCheckShapeIntersection) {
            var firstShapeAttr = helpers_1.getShapeAttributes(firstPoint);
            var nextShapeAttr = helpers_1.getShapeAttributes(nextPoint);
            return (helpers_1.isIntersecting(firstDataLabelAttr, nextDataLabelAttr) ||
                helpers_1.isIntersecting(firstDataLabelAttr, nextShapeAttr) ||
                helpers_1.isIntersecting(firstShapeAttr, nextDataLabelAttr));
        }
        return helpers_1.isIntersecting(firstDataLabelAttr, nextDataLabelAttr);
    });
    if (intersectionFound) {
        dataLabelsHelpers_1.hideDataLabels(points);
    }
    else {
        points.forEach(function (point) { return dataLabelsHelpers_1.showDataLabelInAxisRange(point, point.y, axisRangeForAxes); });
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.autohideBarLabels = function (chart) {
    var isStackedChart = helpers_1.isStacked(chart);
    var visiblePoints = helpers_1.getDataPointsOfVisibleSeries(chart);
    var axisRangeForAxes = helpers_1.getAxisRangeForAxes(chart);
    if (isStackedChart) {
        toggleStackedChartLabels(visiblePoints, axisRangeForAxes);
    }
    else {
        toggleNonStackedChartLabels(visiblePoints, axisRangeForAxes, true);
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.handleBarLabelsOutsideChart = function (chart) {
    var visiblePoints = helpers_1.getDataPointsOfVisibleSeries(chart);
    var axisRangeForAxes = helpers_1.getAxisRangeForAxes(chart);
    visiblePoints.forEach(function (point) {
        if (!helpers_1.isStacked(chart)) {
            dataLabelsHelpers_1.showDataLabelInAxisRange(point, point.y, axisRangeForAxes);
        }
        else {
            // fix for HCH bug for negative stack labels
            dataLabelsHelpers_1.showStackLabelInAxisRange(point, axisRangeForAxes);
        }
    });
};
exports.autohideBarTotalLabels = function (chart) {
    // stack labels are total values displayed on top of columns
    if (dataLabelsHelpers_1.areLabelsStacked(chart)) {
        toggleStackedLabels.call(chart);
    }
};
function toggleStackedLabels() {
    var yAxis = this.yAxis;
    // CL-10676 - Return if yAxis is undefined
    if (!yAxis || yAxis.length === 0) {
        return;
    }
    toggleStackedLabelsForAxis.call(this);
}
function getStackedLabels(stacks) {
    var labels = [];
    for (var stackName in stacks) {
        for (var itemName in stacks[stackName]) {
            for (var item in stacks[stackName][itemName]) {
                labels.push(stacks[stackName][itemName][item].label);
            }
        }
    }
    return labels;
}
function toggleStackedLabelsForAxis() {
    var yAxis = this.yAxis;
    var stackTotalGroups = autohideColumnLabels_1.getStackTotalGroups(yAxis);
    var stacks = autohideColumnLabels_1.getStackItems(yAxis);
    if (stacks && stackTotalGroups) {
        var areOverlapping_1 = autohideColumnLabels_1.areLabelsOverlappingColumns(getStackedLabels(stacks), helpers_1.getDataPointsOfVisibleSeries(this));
        stackTotalGroups.forEach(function (stackTotalGroup) {
            return dataLabelsHelpers_1.setStackVisibilityByOpacity(stackTotalGroup, !areOverlapping_1);
        });
    }
}
exports.toggleStackedLabelsForAxis = toggleStackedLabelsForAxis;
//# sourceMappingURL=autohideBarLabels.js.map